import type { ArticleCardProps } from '@/components/ui/blog-post-card';
import { sitePath } from '@/lib/site-urls';

export const INSIGHTS_POSTS: ArticleCardProps[] = [
  {
    headline: 'Custom Software Development Cost in South Africa',
    excerpt:
      'What really drives custom software development cost in South Africa: scope, integrations, phases and support. Book a Discovery call for a proper quote.',
    cover: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Cost & Pricing',
    readingTime: 720,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-08-14'),
    href: sitePath('/blog/custom-software-development-cost-south-africa'),
  },
  {
    headline: 'Custom Software vs Off-the-Shelf vs a Stack of SaaS Apps',
    excerpt:
      'Custom software vs off-the-shelf vs five SaaS apps held together with Excel: how SA SMEs should decide.',
    cover: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Strategy',
    readingTime: 660,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-08-21'),
    href: sitePath('/blog/custom-software-vs-off-the-shelf'),
  },
  {
    headline: 'Choosing a Software Development Company in Johannesburg',
    excerpt:
      'What to check, red flags to watch for, and how to compare partners before you hire.',
    cover: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Strategy',
    readingTime: 600,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-08-28'),
    href: sitePath('/blog/how-to-choose-software-development-company-johannesburg'),
  },
  {
    headline: 'Questions to Ask a Software Development Company',
    excerpt:
      'Scope, team, cost, ownership, POPIA and support: the questions to ask before you sign.',
    cover: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Strategy',
    readingTime: 600,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-09-04'),
    href: sitePath('/blog/questions-to-ask-custom-software-development-company'),
  },
  {
    headline: 'Does Your SA Business Actually Need Custom Software?',
    excerpt:
      'Signs you need custom software, when you do not, and cheaper steps to try first.',
    cover: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Strategy',
    readingTime: 540,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-09-11'),
    href: sitePath('/blog/when-does-a-small-business-need-custom-software'),
  },
  {
    headline: 'Custom ERP vs Sage, Odoo and Dynamics',
    excerpt:
      'A fair guide to custom ERP software in South Africa versus Sage, Odoo and Dynamics 365, and when to combine them.',
    cover: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Business Systems',
    readingTime: 660,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-09-18'),
    href: sitePath('/blog/custom-erp-vs-sage-odoo-dynamics-south-africa'),
  },
  {
    headline: 'ERP Implementation Services: What SMEs Should Expect',
    excerpt:
      'Discovery, data migration, testing, training and go-live support: what proper ERP implementation should include.',
    cover: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Business Systems',
    readingTime: 660,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-09-25'),
    href: sitePath('/blog/erp-implementation-services-sme-what-to-expect'),
  },
  {
    headline: 'ERP Systems for SMEs in South Africa: When It Makes Sense',
    excerpt:
      'When an ERP makes sense for a growing South African business: modules, integrations, and what to evaluate before you invest.',
    cover: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Business Systems',
    readingTime: 660,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-03-15'),
    href: sitePath('/blog/erp-systems-for-smes-south-africa'),
  },
  {
    headline: 'Workflow Automation Examples for Growing SMEs',
    excerpt:
      'Real automation patterns for South African SMEs: approvals, reporting, customer comms, and operations that save hours every week.',
    cover: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=800&auto=format&fit=crop&q=60',
    tag: 'Automation',
    readingTime: 540,
    writer: 'ThinkinCode Team',
    publishedAt: new Date('2026-03-22'),
    href: sitePath('/blog/workflow-automation-examples-sme'),
  },
];
